import {isEmpty} from 'lodash';

const getFromCookie = (cookies, key) => {
  let filteredCookie = cookies.find((c) => !isEmpty(c[key]));
  return filteredCookie ? filteredCookie[key] : "";
};

export default getFromCookie;
